/**
 * Extracts the most descriptive error message from an Axios or fetch error.
 * Tries backend response body fields first, falls back to the generic error message.
 *
 * Handles common backend shapes, e.g.:
 *   { message: "..." }
 *   { error: "..." }
 *   { detail: "..." }
 *   { type: "validation_error", message: "..." }
 */
export function extractErrorMessage(error, fallback = 'Something went wrong. Please try again.') {
  return (
    error?.response?.data?.message ||
    error?.response?.data?.error ||
    error?.response?.data?.detail ||
    error?.message ||
    fallback
  );
}
